import { getMappedLanguage } from 'i18n/helpers';
import {
  CHAT_SETTINGS_BY_BRAND_ID_ENDPOINT,
  CHAT_SETTINGS_ENDPOINT,
} from './constants';
import { FetchSettingsParameters } from './types';

export const makeGetChatSettingsEndpoint = (
  parameters: FetchSettingsParameters,
) => {
  const brandId = parameters?.brandId;
  const lang = parameters?.lang;

  let endpoint = CHAT_SETTINGS_ENDPOINT;

  if (brandId) {
    endpoint = `/p/v2/chat/brands/${brandId}/settings`;
  }

  const mappedLang = getMappedLanguage(lang);

  if (lang) {
    endpoint = `${endpoint}?lang=${mappedLang}`;
  }

  return endpoint as
    | typeof CHAT_SETTINGS_ENDPOINT
    | typeof CHAT_SETTINGS_BY_BRAND_ID_ENDPOINT;
};
